import React from 'react';
import styled from 'styled-components';
import SwiperCore, { A11y, Lazy, Navigation, Pagination } from 'swiper';
import 'swiper/components/effect-coverflow/effect-coverflow.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import { CustomPagination } from '../Home.style';
import Card from './BlogCard';
import { useGetDashboardBlog } from 'untils/hook/blog/blog.hook';
import { flexGap } from 'untils/polyfill/flex';
import { vw } from 'components/common/Common';

SwiperCore.use([Lazy, Navigation, A11y, Pagination]);

const Container = styled.div`
  width: var(--home-section-width);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: var(--home-section-top-padding) 0;
  ${flexGap('30px')}

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: max-content;
    height: 440px;
    margin-right: 16px;
    background: #f5f9fe;
    border-radius: 4px;
  }
`;

const BlogBody = styled.div`
  width: 100%;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 16px;
  border-bottom: 1px solid #dde2e4;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  ${flexGap('16px')}
  max-width: 572px;
`;

const TitleHeader = styled.h2`
  font-weight: 600;
  font-size: 40px;
  margin: 0;
`;

const Tips = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
  color: #424748;
`;

const Desc = styled.div`
  width: 100%;
  font-weight: 600;
  font-size: ${vw(12)};
  color: #050a30;
`;

const ViewMoreLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  color: #050a30;
  width: 180px;
  height: 37px;
  border-radius: 4px;
  border: 1px solid #050a30;
  cursor: pointer;
  &:hover {
    color: #050a30;
  }
`;

const EmptyLegComponent = () => {
  const { data } = useGetDashboardBlog();

  return (
    <Container>
      <Header>
        <Title>
          <div>
            <TitleHeader>Airacer Blog</TitleHeader>
            <Tips>
              Keep up-to-date on popular and exclusive private jet charter destinations <br />
              and events.
            </Tips>
          </div>
        </Title>
        <CustomPagination id="empty-pagination" />
        <ViewMoreLink href="/blog">View more</ViewMoreLink>
      </Header>
      <BlogBody>
        {data && (
          <Swiper
            slidesPerView="3"
            lazy
            pagination={{
              renderCustom: function (_, current, total) {
                return `<span>${current}</span> / <span>${total}</span>`;
              },
              type: 'custom',
              el: '#empty-pagination',
            }}
          >
            {data.map((item) => {
              return (
                <SwiperSlide key={item.Id}>
                  <Card item={item} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </BlogBody>
    </Container>
  );
};

export default EmptyLegComponent;
